module.exports = __webpack_public_path__ + "media/media/product-card/product-set-5a216600a8cb5ba1b51d396c523e8e92.jpg";